import { ReactComponent as BanSvg } from "../../assets/images/svgs/ban.svg";

const BanIcon = ({ className = "", ...props }) => {
  return (
    <BanSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default BanIcon;
